import React, { Component } from "react";
import { connect } from "react-redux";
import { logoutUserSession } from "../../actions/userLogActions";
import {
  Col, Row, Form, Button,
} from 'react-bootstrap';

class UserSessionLOgout extends Component {
  constructor() {
    super();
    this.state = {
      userId: '',
      error: '',
    };
  }

  handleLogout = (userId) => {
    if (!userId) {
      this.setState({ error: 'Please Enter User ID' });
      return;
    }
    logoutUserSession(userId);
    this.setState({ userId: '', error: '' });
  };

  onChange = (e) => {
    const { value } = e.target;
    this.setState({ userId: value });
  };


  render() {
    return (
      <div>
        <Row>
          <Col sm={4} />
          <Col sm={4}>
            <div className="container" id="container">
              <h2 id="fontSize">Sign Out User Everywhere</h2>
              <form id="form">
                <Row>
                  <Form.Group>
                    <Form.Label> User ID</Form.Label>
                    <Form.Control
                      type="text"
                      onChange={this.onChange}
                      value={this.state.userId}
                      id="userId"
                      name="userId"
                      size="lg"
                    />
                    <Form.Label style={{ color: 'red' }}> {this.state.error}</Form.Label>
                  </Form.Group>
                </Row>

                <Row>
                  <Button onClick={() => this.handleLogout(this.state.userId)} id="fontSize20px">
                    Logout from All devices
                  </Button>
                </Row>
              </form>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  Logs: state.logs.logs,
});

export default connect(mapStateToProps, {
  logoutUserSession
})(UserSessionLOgout);
